import { AiBlock } from "@/components/ax/AiBlock";
import { Field } from "@/components/ax/Field";
import { useI18n } from "@/i18n";

export const StepNotes = ({ s }) => {
  const { t } = useI18n();
  return (
    <div data-testid="intake-step-2" className="enter mt-8 flex flex-col gap-4">
      <Field
        multiline
        label={t("notes.label")}
        maxLength={2000}
        value={s.note}
        onChange={(e) => s.setNote(e.target.value)}
        hint={s.note.length >= 2000 ? t("notes.cut") : undefined}
        testId="intake-note-input"
        className="[&_textarea]:min-h-[160px]"
      />
      {!s.aiOn && (
        <p data-testid="ai-no-consent" className="m-0 text-sm leading-5 text-ax-muted">
          {t("ai.noConsent")}
        </p>
      )}
      {s.aiOn && s.parsedNote === null && (
        <p data-testid="ai-quota" className="m-0 font-mono text-[13px] leading-[18px] text-ax-muted">
          {t("ai.quota", { n: s.left })}
        </p>
      )}
      {s.parsedNote !== null && (
        <AiBlock title={t("ai.proposals")} testId="parse-result">
          {s.suggestions.length > 0 && (
            <ul className="m-0 flex list-none flex-col gap-2 p-0 text-base leading-6 text-ax-text">
              {s.suggestions.map((x) => (
                <li key={x.id} className="[overflow-wrap:anywhere]">
                  {x.text}
                </li>
              ))}
            </ul>
          )}
          <p className="m-0 mt-3 font-mono text-[13px] leading-[18px] text-ax-muted">{t("ai.preview")}</p>
        </AiBlock>
      )}
    </div>
  );
};
